import { ContentType } from '@/graphql/graphql';
import { Link } from '@/i18n/navigation';
import type { CategoryDropdownMenu } from '@/types/categories';
import { useTranslations } from 'next-intl';
import { useSearchParams } from 'next/navigation';
import { NAVIGATION_ITEM_CLASS, NAVIGATION_LAST_ITEM_CLASS, NavigationDropDown } from './navigation-dropdown';

type Props = {
    isActive?: boolean;
    categories: CategoryDropdownMenu[];
    contentType?: ContentType;
    onLinkClickAction?: () => void;
};

export const CategoriesDropDown = ({ isActive, categories, contentType, onLinkClickAction }: Props) => {
    const t = useTranslations('Navigation');
    const searchParams = useSearchParams();
    const activeItemClass =
        'whitespace-nowrap flex items-center gap-2 rounded-[8px] p-[10px] my-2 relative w-full text-left text-base bg-[#DD06AE]';

    const currentCategoryParam = searchParams.get('category');
    const currentGensParam = searchParams.get('gens');
    const hasActiveFilter = !!currentCategoryParam || !!currentGensParam;

    const isCategoryActive = (categoryId: string, isGenre?: boolean) => {
        if (isGenre) return currentGensParam === categoryId;
        return currentCategoryParam === categoryId;
    };

    const basePath = contentType === ContentType.Format ? '/formats' : '/programs';

    const handleLinkClick = (close: () => void) => {
        close();
        onLinkClickAction?.();
    };
    return (
        <NavigationDropDown
            label={t(contentType === ContentType.Format ? 'formats' : 'programs')}
            isActive={isActive}
            panelClassName="max-h-[440px] sm:max-h-[initial] overflow-y-auto"
        >
            {(close) => (
                <>
                    <li>
                        <Link
                            className={
                                isActive && !hasActiveFilter
                                    ? activeItemClass
                                    : `whitespace-nowrap ${NAVIGATION_ITEM_CLASS}`
                            }
                            href={basePath}
                            onClick={() => handleLinkClick(close)}
                        >
                            {t(contentType === ContentType.Format ? 'allFormats' : 'allPrograms')}
                        </Link>
                    </li>
                    {categories.map((category, index, array) => {
                        return (
                            <li key={category.id}>
                                <Link
                                    className={`${isCategoryActive(category.id, category.isAnExcludedGenre) ? activeItemClass : `whitespace-nowrap ${NAVIGATION_ITEM_CLASS}`} ${index === array.length - 1 && array.length > 1 ? NAVIGATION_LAST_ITEM_CLASS : ''}`}
                                    href={{
                                        pathname: basePath,
                                        query: {
                                            [category.isAnExcludedGenre ? 'gens' : 'category']: category.id,
                                        },
                                    }}
                                    onClick={() => handleLinkClick(close)}
                                >
                                    {category.title as string}
                                </Link>
                            </li>
                        );
                    })}
                </>
            )}
        </NavigationDropDown>
    );
};
